export default "__VITE_ASSET__BhdS_FLH__"